import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';
import { PremiseHazardType } from '@premise-hazard-type-models/premise-hazard-type.model';
import { Units } from '@models/units.model';
import { UserService } from '@services/user.service';
import { UnitConverterService } from '@services/unit-converter.service';
import { TemplateConstants } from '../../constants/template-constants';
import { CurrentUnitsService } from '@services/current-units.service';
import { PremiseHazardQueryRestService } from '@services/rest/premise-hazard-rest.service';
import { BaseViewComponent } from '@app/shared/base-view.component';

@Component({
    selector: 'app-premise-hazard-type-view',
    templateUrl: './premise-hazard-type-view.component.html',
    styleUrls: ['./premise-hazard-type-view.component.scss'],
    standalone: false
})
export class PremiseHazardTypeViewComponent extends BaseViewComponent implements OnInit, OnChanges {
  @Input() PremiseHazardType!: PremiseHazardType | undefined;

  dateFormat: string = 'dd/MM/yyyy HH:mm a zzzz';

  defaultDirectHitDistanceMeters: number = 5;

  public selectedUnits!: Units;
  UNITS = TemplateConstants.Units;
  NUMBER_FORMATS = TemplateConstants.NumberFormats;

  directHitDistanceDisplay: number = 0;
  innerProximityDistanceDisplay: number = 0;
  outerProximityDistanceDisplay: number = 0;
  showExpandedInformation: boolean = true;
  public currentUnitsText!: string;

  public infoCalloutType = TemplateConstants.InfoCalloutType;

  constructor(private converterService: UnitConverterService,
    userService: UserService,
    cdr: ChangeDetectorRef,
    private transloco: TranslocoService,
    private unitsService: CurrentUnitsService,
    private queryService: PremiseHazardQueryRestService,) {
    super(userService, cdr);
  }

  private loadTranslations(): void {
    this.transloco.selectTranslate(`Units.${Units[this.selectedUnits].toLowerCase()}`).pipe(take(1)).subscribe(res => this.currentUnitsText = res);
    this.transloco.selectTranslate('Formats.date.short').pipe(take(1)).subscribe(res => this.dateFormat = res);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.PremiseHazardType) {
      this.showExpandedInformation = true;
      this.updateProximities();
      this.setSharingInfo(this.PremiseHazardType);
    }
    this.loadLatestPremiseHazardType();
  }

  ngOnInit(): void {
    this.selectedUnits = this.unitsService.getCurrentUnits();
    this.loadTranslations();
    this.setSharingInfo(this.PremiseHazardType);
    if (this.PremiseHazardType) {
      this.showExpandedInformation = !(this.PremiseHazardType.directHitAudio === null &&
        this.PremiseHazardType.directHitVisual === null &&
        this.PremiseHazardType.innerProximityAudio === null &&
        this.PremiseHazardType.innerProximityVisual === null &&
        this.PremiseHazardType.outerProximityAudio === null &&
        this.PremiseHazardType.outerProximityVisual === null);
      this.updateProximities();
    }
    this.loadLatestPremiseHazardType();
  }

  setPremiseHazardType(premiseHazardType: PremiseHazardType): void {
    this.PremiseHazardType = premiseHazardType;
  }

  private loadLatestPremiseHazardType(): void {
    if (!this.PremiseHazardType || !this.shouldLoadItem(this.PremiseHazardType.id)) {
      return;
    }
    this.queryService.getPremiseHazardType(this.PremiseHazardType.id)
      .pipe(take(1))
      .subscribe((response) => {
        this.eTag = response.ETag;
        if (response.Item) {
          this.setPremiseHazardType(response.Item);
          this.updateProximities();
          this.setSharingInfo(this.PremiseHazardType);
        }
      });
  }

  private updateProximities(): void {
    if (!this.PremiseHazardType) {
      return;
    }
    if (this.PremiseHazardType.directHitDistance) {
      this.directHitDistanceDisplay = this.converterService.fromMeters(this.PremiseHazardType.directHitDistance, this.selectedUnits);
    } else {
      this.directHitDistanceDisplay = this.converterService.fromMeters(this.defaultDirectHitDistanceMeters, this.selectedUnits);
    }
    this.innerProximityDistanceDisplay = this.converterService.fromMeters(this.PremiseHazardType.innerProximityDistance, this.selectedUnits);
    this.outerProximityDistanceDisplay = this.converterService.fromMeters(this.PremiseHazardType.outerProximityDistance, this.selectedUnits);
  }
}
